import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PaymentListLayer from "../../components/ChatPaymentTransaction/ChatPaymentListLayer";


const ChatPaymentList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Chat Payment" />

        {/* PaymentListLayer */}
        <PaymentListLayer />

      </MasterLayout>

    </>
  );
};

export default ChatPaymentList; 
